// ABOUTME: Idea chips under the seeded welcome message while a conversation is pristine: the
// business's own content themes and services (useBusinessIdeas), none when it has neither. A tap
// seeds the composer with the ask, so the first message costs one tap plus Send. Rendered by
// ChatSurface, so the floating panel and /chat get identical treatment by construction.

import { ideaAsk, useBusinessIdeas } from '@/hooks/useBusinessIdeas'

interface WelcomeSuggestionsProps {
  /** Seed the composer with this prompt (and focus the input). */
  onPick: (prompt: string) => void
}

export function WelcomeSuggestions({ onPick }: WelcomeSuggestionsProps) {
  const ideas = useBusinessIdeas()
  if (ideas.length === 0) return null
  return (
    <div className="flex flex-col items-start gap-1.5 pl-2" data-testid="welcome-suggestions">
      {ideas.map((idea) => (
        <button
          key={idea}
          type="button"
          onClick={() => onPick(ideaAsk(idea))}
          className="border-primary/30 text-primary hover:bg-primary/10 max-w-full truncate rounded-full border px-3 py-1.5 text-left text-xs font-medium transition-colors pointer-coarse:min-h-11"
          data-testid="chat-suggestion"
        >
          {ideaAsk(idea)}
        </button>
      ))}
    </div>
  )
}
